import React from 'react';
import Icon from '../../../components/AppIcon';
import { parseLocalDate } from '../../../utils/dateUtils';

const ProjectTimelineChart = ({ projects }) => {
  const getStatusColor = (status) => {
    const colors = {
      'On Track': 'bg-success',
      'At Risk': 'bg-warning',
      'Delayed': 'bg-error',
      'Completed': 'bg-primary'
    };
    return colors?.[status] || 'bg-muted';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'On Track': 'CheckCircle',
      'At Risk': 'AlertCircle',
      'Delayed': 'AlertTriangle',
      'Completed': 'CheckCircle2'
    };
    return icons?.[status] || 'Circle';
  };

  const calculateProgress = (startDate, endDate) => {
    const now = new Date();
    const start = parseLocalDate(startDate);
    const end = parseLocalDate(endDate);
    const total = end - start;
    const elapsed = now - start;
    return Math.min(Math.max((elapsed / total) * 100, 0), 100);
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Active Projects Timeline</h3>
        <Icon name="Calendar" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-4 md:space-y-5">
        {projects?.map((project) => {
          const progress = calculateProgress(project?.startDate, project?.endDate);
          return (
            <div key={project?.id} className="border-b border-border pb-4 last:border-0 last:pb-0">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base font-medium text-foreground line-clamp-1 mb-1">{project?.name}</h4>
                  <p className="text-xs text-muted-foreground">{project?.customer}</p>
                </div>
                <div className={`flex items-center gap-1 px-2 py-1 rounded-md ${getStatusColor(project?.status)} bg-opacity-10`}>
                  <Icon name={getStatusIcon(project?.status)} size={14} className={getStatusColor(project?.status)?.replace('bg-', 'text-')} />
                  <span className={`text-xs font-medium ${getStatusColor(project?.status)?.replace('bg-', 'text-')}`}>{project?.status}</span>
                </div>
              </div>
              <div className="relative h-2 bg-muted rounded-full overflow-hidden mb-2">
                <div 
                  className={`absolute left-0 top-0 h-full ${getStatusColor(project?.status)} transition-all duration-500`}
                  style={{ width: `${progress}%` }}
                />
              </div>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>{parseLocalDate(project?.startDate)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span>
                <span>{Math.round(progress)}% complete</span>
                <span>{parseLocalDate(project?.endDate)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectTimelineChart;